import React, { useEffect, useState } from 'react';

export default function Acknowledgement({
  onUpdate,
}: {
  onUpdate: (value: boolean) => void;
}): React.JSX.Element {
  const [isChecked, setIsChecked] = useState(false);

  useEffect(() => {
    onUpdate(isChecked);
  }, [isChecked, onUpdate]);

  return (
    <div className='md:flex mb-5'>
      <div className='md:w-full my-2'>
        <div className='page-text-alert'>
          <div
            className='flex items-center cursor-pointer'
            onClick={(): void => setIsChecked(!isChecked)}
          >
            <input
              type='checkbox'
              onChange={(): void => setIsChecked(!isChecked)}
              checked={isChecked}
            />
            <p className='mx-2 text font-medium'>
              I Acknowledge & Confirm the Following:
            </p>
            <span className=' text-red-500 text-base font-medium'>*</span>
          </div>
          <p className='text'>
            The above information has been confirmed by my financial
            administrator and I understand that once funds have been raised the
            payable organization cannot be changed.
          </p>
        </div>
      </div>
    </div>
  );
}
